export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5241/api',
  X_API_KEY: process.env.REACT_APP_X_API_KEY || '6735307e6c2c7a7e4828de01',
  TIMEOUT: 600000,
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};
export const API_CONFIG_OMISIONES = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL_OMISIONES || 'https://omisiones.quro.com.mx:8095',
  TIMEOUT: 30000,
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

export const QURO_GPS_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL_QURO || 'http://localhost:3576',
};

export const QURO_MAP_CONFIG = {
  BASE_URL: process.env.REACT_APP_MAP_BASE_URL || 'https://reporteria.quro.com.mx:10061',
};